(function () {
  if (window.bgSnackbar) return;
  var STYLE_ID = 'bg-snackbar-style';
  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '#bg-snackbar-wrap{position:fixed;top:20px;right:20px;z-index:2147483647;display:flex;flex-direction:column;gap:10px;pointer-events:none;}' +
      '.bg-snackbar{display:flex;align-items:center;gap:8px;min-width:200px;max-width:320px;background:#0e3161;color:#fff;padding:12px 16px;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,.18);font-size:14px;line-height:1.35;font-weight:500;transform:translateX(120%);opacity:0;transition:transform .35s cubic-bezier(.22,1,.36,1),opacity .35s ease;pointer-events:auto;}' +
      '.bg-snackbar.show{transform:translateX(0);opacity:1;}' +
      '.bg-snackbar svg{flex:0 0 auto;}' +
      '@media (max-width:600px){#bg-snackbar-wrap{top:12px;right:12px;left:12px;}.bg-snackbar{max-width:none;width:100%;}}';
    document.head.appendChild(s);
  }
  function getWrap() {
    var w = document.getElementById('bg-snackbar-wrap');
    if (!w) { w = document.createElement('div'); w.id = 'bg-snackbar-wrap'; (document.body || document.documentElement).appendChild(w); }
    return w;
  }
  var CHECK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6L9 17l-5-5" stroke="#7CFC9B" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  window.bgSnackbar = function (message, opts) {
    opts = opts || {};
    try {
      ensureStyle();
      var wrap = getWrap();
      var el = document.createElement('div');
      el.className = 'bg-snackbar';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      var span = document.createElement('span');
      span.textContent = message || 'Added to cart';
      if (opts.icon !== false) { var i = document.createElement('span'); i.innerHTML = CHECK; el.appendChild(i.firstChild); }
      el.appendChild(span);
      wrap.appendChild(el);
      requestAnimationFrame(function () { el.classList.add('show'); });
      var dur = opts.duration || 2500;
      setTimeout(function () {
        el.classList.remove('show');
        setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 450);
      }, dur);
    } catch (e) {}
  };
})();
